import BaseMetricHandler from "./BaseMetricHandler";

const seriesColorMapping = {
  all: "#F8A601",
  screen: "#6D73EE",
  interview: "#2A85F2",
  offer: "#27A568",
  joined: "#186741",
  drop: "#ED4C4C",
  reject: "#C70202",
};

export default class CandidateApplicationFunnelHandler extends BaseMetricHandler {
  constructor(groupBy, filterBy) {
    super(groupBy, filterBy);
    this.graphType = "";
    this.dataType = "counts";
  }

  getGraphColor(label) {
    return seriesColorMapping[label];
  }

  getGraphOptions(backendData) {
    let series = backendData.data.map((value, index) => {
      return {
        name: backendData.labels[index],
        value: value,
      };
    });

    let options = {
      tooltip: {
        trigger: "item",
        formatter: "{a} <br/><b>{b}:</b> {c}",
      },
      toolbox: {
        // feature: {
        //   saveAsImage: {},
        // },
      },
      legend: {
        data: backendData.labels,
        top: "bottom",
      },
      color: backendData.labels.map((label) => this.getGraphColor(label)),
      series: [
        {
          name: "Candidate application funnel",
          type: "funnel",
          // left: "10%",
          top: 60,
          bottom: 60,
          width: "80%",
          min: backendData.min_value,
          max: backendData.max_value,
          minSize: "0%",
          maxSize: "80%",
          sort: "descending",
          gap: 5,
          label: {
            show: true,
            position: "right",
            formatter: "{b}: {c}",
            fontWeight: "bold",
          },
          labelLine: {
            length: 10,
            lineStyle: {
              width: 1,
              type: "solid",
            },
          },
          itemStyle: {
            borderColor: "#fff",
            borderWidth: 1,
          },
          emphasis: {
            label: {
              fontSize: 20,
            },
            disabled: true,
          },
          data: series,
        },
      ],
    };
    return options;
  }

  getTableRepresentation(backendData) {
    let tableRows = [];
    if (backendData.length === 0) {
      return tableRows;
    }
    let labels = backendData.labels.slice(0, BaseMetricHandler.MaxLabels());

    tableRows.push(["Label", "Value", "Percentage"]);

    labels.forEach((label, index) => {
      let thisRow = [
        label,
        backendData.data[index],
        (backendData.total === 0
          ? 0
          : ((backendData.data[index] * 100.0) / backendData.total).toFixed(2)
        ).toString() + "%",
      ];
      tableRows.push(thisRow);
    });

    return tableRows;
  }
}
